/**
 * Official BNM S.R.L. corporate data — verified Source of Truth
 * (production data package, June 2026). Do not edit without an
 * updated official package.
 */

export const CANONICAL_ORIGIN = "https://bnmgroup.it";

export const COMPANY = {
  legalName: "BNM S.R.L.",
  legalForm: "Società a Responsabilità Limitata (S.R.L.)",
  status: { en: "Active", it: "Attiva" },
  address: {
    street: "Via Antonio Vivaldi, 12",
    city: "56022 Castelfranco di Sotto (PI)",
    country: { en: "Italy", it: "Italia" },
  },
  website: "https://bnmgroup.it",
  websiteLabel: "bnmgroup.it",
  email: "info@bnmgroup.it",
  pec: "bnmsrl@arubapec.it",
  phone: "+39 349 704 3345",
  phoneHref: "tel:+393497043345",
  vat: "06654120481",
  vatIntl: "IT06654120481",
  taxCode: "06654120481",
  rea: "PI-258592",
  registeredWith: "Camera di Commercio Toscana Nord-Ovest",
  shareCapital: { en: "€10,000.00 fully paid", it: "€ 10.000,00 interamente versato" },
  chairman: "Bahram Nikmahzar",
  boardMember: "Morteza Nikmahzar",
  eoriEU: "IT06654120481",
  eoriUK: "GB047109919000",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=Via+Antonio+Vivaldi+12%2C+56022+Castelfranco+di+Sotto+PI%2C+Italy",
  /** Official business hours (Europe/Rome). */
  businessHours: {
    weekdays: { open: "09:00", close: "18:00" },
    weekend: "closed",
    timezone: "Europe/Rome",
  },
} as const;
